// How a floor-plan SVG names its areas — Trusstor's convention
// (`trusstor_dashboard/shared/utils/svg.utils.ts`). Each area polygon, or the
// group wrapping it, carries an id like `area<areaId>` or
// `f<floorId>area<areaId>`; export tools sometimes append `_<suffix>`
// (`area101_3`). Both apps read area ids off the plan through these.

/** Whether an element id names an area. */
export function isAreaElementId(elementId: string): boolean {
  return elementId.includes('area');
}

/** The id without an export tool's `_<suffix>`, so lookups are stable. */
export function cleanAreaElementId(elementId: string): string {
  return elementId.split('_')[0] || elementId;
}

/** `area101` → `101`, `f-1area-101` → `-101`. Empty string when unparseable. */
export function getAreaIdFromElementId(elementId: string): string {
  if (elementId.startsWith('f')) return elementId.split('area')[1] ?? '';
  return elementId.replace('area', '');
}
